import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, AlertTitle, Box, Button, IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { api } from '../services/AuthService';

const DISMISSED_KEY = '@AllDelivery:dismissedUpdateAnnouncement';

export default function UpdateAnnouncement() {
  const [announcement, setAnnouncement] = useState(null);
  const location = useLocation();
  const isCustomerPwa = location.pathname === '/pedir' || location.pathname === '/app' || location.pathname.startsWith('/app/');

  const loadAnnouncement = useCallback(async () => {
    try {
      const { data } = await api.get('/app-updates/android');
      const id = data?.announcement_id || data?.announcement_published_at;
      if (!data?.announcement_enabled || !id || localStorage.getItem(DISMISSED_KEY) === String(id)) {
        setAnnouncement(null);
        return;
      }
      setAnnouncement({ ...data, announcement_id: String(id) });
    } catch (_) {
      // O aviso é informativo e não deve impedir o uso offline ou quando a API estiver indisponível.
    }
  }, []);

  useEffect(() => {
    loadAnnouncement();
    const refresh = () => loadAnnouncement();
    window.addEventListener('focus', refresh);
    const timer = window.setInterval(refresh, 5 * 60 * 1000);
    return () => {
      window.removeEventListener('focus', refresh);
      window.clearInterval(timer);
    };
  }, [loadAnnouncement]);

  if (!announcement) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, announcement.announcement_id);
    setAnnouncement(null);
  };

  return (
    <Box sx={{ position: 'fixed', top: { xs: 10, sm: 20 }, left: '50%', transform: 'translateX(-50%)', width: 'min(720px, calc(100% - 24px))', zIndex: 1600 }}>
      <Alert
        severity="info"
        icon={<SystemUpdateAltIcon />}
        action={(
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Button color="inherit" size="small" onClick={() => window.location.reload()}>
              Atualizar
            </Button>
            <Button color="inherit" size="small" href={announcement.announcement_url || 'https://alldelivery.online/pedir'}>
              {isCustomerPwa ? 'Abrir pedidos' : 'App de pedidos'}
            </Button>
            <IconButton aria-label="Fechar aviso de atualização" color="inherit" size="small" onClick={dismiss}><CloseIcon fontSize="small" /></IconButton>
          </Stack>
        )}
        sx={{ alignItems: 'center', boxShadow: 4, borderRadius: 3, '& .MuiAlert-message': { width: '100%' } }}
      >
        <AlertTitle>{announcement.announcement_title || 'Nova atualização disponível'}</AlertTitle>
        {announcement.announcement_message || 'Atualize para usar os novos recursos do All Delivery.'}
        <Box component="div" sx={{ mt: 0.5, fontWeight: 700, fontSize: 13 }}>
          Atualize para usar todos os recursos do aplicativo. Você pode fechar este aviso e atualizar depois.
        </Box>
      </Alert>
    </Box>
  );
}
